// Well-known, stable requirement ids from the Audit Orchestrator. A selected workpaper carrying one of
// these means the corresponding misstatement field becomes required in the Run Audit Workpapers modal.
export const REQUIREMENT_TOLERABLE_MISSTATEMENT_ID = 'a1b2c3d4-1a2b-4c3d-9e4f-0a1b2c3d4e5f';
export const REQUIREMENT_TRIVIAL_MISSTATEMENT_ID = 'a1b2c3d4-2a2b-4c3d-9e4f-0a1b2c3d4e5f';
